/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  ActionLogDTO,
  Address,
  AddressInfoDTO,
  AddressJudgmentResult,
  AddressVerifyRequest,
  AddressVerifyResponse,
  AiCargoDTO,
  AiResultResponse,
  AllocateDTO,
  AllocateRequest,
  BatchAllocateRequest,
  BizOperRequest,
  BizOperResponse,
  CancelShipmentRequest,
  CarParamConfigDTO,
  CarrierCountDTO,
  CarrierCountResponse,
  CityDTO,
  CommissionAuditRequest,
  CompanyAddRequest,
  CompanyAuditRequest,
  CompanyDetailResponse,
  CompanyEditRequest,
  CompanyPageResponse,
  CompanyQueryRequest,
  CompanyStatusRequest,
  CreditEditRequest,
  CustomPlatformConfigPageResponse,
  CustomPlatformConfigQueryRequest,
  CustomPlatformConfigRequest,
  CustomPlatformConfigResponse,
  CustomerCreditResponse,
  CustomerFtlQuoteConfigDTO,
  CustomerQuoteConfigDTO,
  CustomerQuoteInfoDTO,
  CustomerQuoteInfoDetailDTO,
  CustomerQuoteServiceDetailDTO,
  CustomerResponse,
  DriverAddRequest,
  DriverDetailResponse,
  DriverInfoDTO,
  DriverPageResponse,
  DriverQueryRequest,
  DriverStatusRequest,
  ExceptionDealDetailResponse,
  ExceptionDealRequest,
  ExceptionDetailResponse,
  ExceptionPageResponse,
  ExceptionQueryRequest,
  FCashOutApproveRequest,
  FCashOutListResponse,
  FCashOutQueryRequest,
  FCashOutResponse,
  FCustomerWalletRequest,
  FCustomerWalletResponse,
  FHistoryBillRequest,
  FRechargeApproveRequest,
  FRechargeListResponse,
  FRechargeQueryRequest,
  FRechargeRequest,
  FRechargeResponse,
  FTradeRequest,
  FTransactionResponse,
  FWalletResponse,
  FmcsaCarrier,
  FmcsaCarrierListVO,
  FmcsaQueryRequest,
  FmcsaReamrkResponse,
  FmcsaStatusRequest,
  FreightClassRequest,
  FtlAcceptRequest,
  FtlAddStopRequest,
  FtlAddressIdDTO,
  FtlAddressResponse,
  FtlAmountDTO,
  FtlCargoDTO,
  FtlExactAddressDTO,
  FtlExactQuoteRequest,
  FtlOrderAmountRequest,
  FtlOrderAmountResponse,
  FtlOrderBackRequest,
  FtlOrderBatchIdRequest,
  FtlOrderCreateRequest,
  FtlOrderDetailExtResponse,
  FtlOrderDriverUpdateRequest,
  FtlOrderListExtResponse,
  FtlOrderPickDateRequest,
  FtlOrderPriceUpdateRequest,
  FtlOrderQueryRequest,
  FtlOrderRefNumberUpdateRequest,
  FtlOrderRemarkUpdateRequest,
  FtlQuoteConfigDTO,
  FtlQuoteConfigPageResponse,
  FtlQuoteConfigQueryRequest,
  FtlQuoteConfigRequest,
  FtlQuoteConfigResponse,
  FtlQuoteInfoDTO,
  FtlQuoteInfoDetailDTO,
  FtlQuoteResponse,
  FtlQuoteResultDTO,
  FtlRearrangeRequest,
  FtlStopFeeInfoDTO,
  FtlWaybillAllocateRequest,
  FtlWaybillAmountRecordDTO,
  FtlWaybillAmountUpdateRequest,
  FtlWaybillBolNoUpdateRequest,
  FtlWaybillDetailResponse,
  FtlWaybillListResponse,
  FtlWaybillPriceRequest,
  FtlWaybillPriceResponse,
  FtlWaybillRemarkUpdateRequest,
  FtlWaybillStatusRequest,
  FtlWaybillTrackLogResponse,
  FtlWaybillUpdateRequest,
  HazardInfoDTO,
  HelperInfoReqeust,
  IPage,
  LocalTime,
  LocalTimeReq,
  LocalTimeRes,
  MailQuoteConfigResponse,
  MainQuoteConfigPageResponse,
  MainQuoteConfigQueryRequest,
  MainQuoteConfigRequest,
  OrderAcceptRequest,
  OrderActionLogResponse,
  OrderAddressDTO,
  OrderAddressDTOReq,
  OrderAddressDTORes,
  OrderAmountRecordDTO,
  OrderAmountRequest,
  OrderAmountResponse,
  OrderBatchIdRequest,
  OrderBidPriceRequest,
  OrderBillToVo,
  OrderCargoDTO,
  OrderCountDTO,
  OrderCountResponse,
  OrderDetailResponse,
  OrderFileRequest,
  OrderListExtResponse,
  OrderPickDateRequest,
  OrderPickupInfoRequest,
  OrderPriceUpdateRequest,
  OrderQueryRequest,
  OrderQuoteDTO,
  OrderQuoteRequest,
  OrderQuoteResultResponse,
  OrderRefNumberUpdateRequest,
  OrderRequest,
  OrderSimpleCargoDTO,
  OrderSimpleInfoDTO,
  OrderTrackingDTO,
  OssFileResponse,
  OwnerQueryRequest,
  OwnerUserAuditRequest,
  OwnerUserEditRequest,
  OwnerUserLevelRequest,
  OwnerUserPwdRequest,
  OwnerUserRequest,
  OwnerUserResponse,
  PackageItemsDTO,
  PageQuery,
  PlaceDetailResponse,
  PlaceResultDTO,
  PlaceResultResponse,
  PlaceSearchRequest,
  PlatformCommodityDTO,
  PlatformConfigDetailDTO,
  PlatformOrderCoreRequest,
  PlatformQuoteRateDTO,
  PlatformRateDetailDTO,
  QueryCityPageDTO,
  QueryQuoteAmountDTO,
  QuoteConfigDTO,
  QuoteConfigUpdateDTO,
  QuoteConfigUpdateRequest,
  QuoteInfoDTO,
  QuoteInfoDetailDTO,
  QuoteOrderPriceDTO,
  QuoteResultResponse,
  QuoteServiceDetailDTO,
  RouteDetailResponse,
  R,
  SalesAmountReportResponse,
  SalesCustomerRequest,
  SalesCustomerResponse,
  SalesDetailResponse,
  SalesOrderCountRequest,
  SalesOrderRequest,
  SalesOrderResponse,
  SalesQueryRequest,
  SalesSimpleResponse,
  SalesUserRequest,
  SalesUserResponse,
  SalesUserStatusVo,
  ServiceExtraQuoteDetailDTO,
  ServiceQuoteConfigRequest,
  ServiceQuoteConfigResponse,
  ServiceQuoteConfigUpdateRequest,
  ServiceQuoteDetailDTOReq,
  ServiceQuoteDetailDTORes,
  ShipmentCountResponse,
  ShipmentDetailExtResponse,
  ShipmentPageExtResponse,
  ShipmentQueryRequest,
  ShipmentTrackResponse,
  SimpleDriverListResponse,
  SimpleDriverQueryRequest,
  SimpleTruckListResponse,
  SimpleTruckQueryRequest,
  SysDepartmentTreeVo,
  SysDepartmentVo,
  SysPermission,
  SysPermissionTreeVo,
  SysPermissionVo,
  SysRoleResultVo,
  SysRoleVo,
  SysUserPasswordVo,
  SysUserQueryVo,
  SysUserStatusVo,
  SysUserVo,
  TimeZoneDTO,
  TrackInfo,
  TrackQueryRequest,
  TransferCenterQueryRequest,
  TransferCenterRequest,
  TransferCenterResponse,
  TranslateRequest,
  TranslateResponse,
  TruckAddOrEditRequest,
  TruckBindRequest,
  TruckDetailResponse,
  TruckPageQueryRequest,
  TruckPageResponse,
  TruckStatusRequest,
  UpdateBatchIdDTO,
  UpdateQuoteConfigDisableDTO,
  UserInfoVo,
  UserLoginVo,
  WaybillActionLogFileResponse,
  WaybillActionLogResponse,
  WaybillBolNoUpdateRequest,
  WaybillCountDTO,
  WaybillCountResponse,
  WaybillDetailResponse,
  WaybillFileResponse,
  WaybillPriceRecordDTO,
  WaybillPriceRequest,
  WaybillPriceResponse,
  WaybillPriceUpdateRequest,
  WaybillQueryRequest,
  WaybillRemarkUpdateRequest,
  WaybillRouteInfoDTO,
  WaybillRouteResponse,
  WaybillTrackLogResponse,
  WaybillTruckUpdateRequest,
  WaybillUpdateDriverRequest,
  WaybillUpdateRequest,
  WnChannelCommissionDTO,
} from './type';
import request from '@/utils/request';

export class FtlOrderService {
  // 打回整车订单
  public static backFtlOrderUsingPUT(batchIdRequest: FtlOrderBackRequest): Promise<R<string>> {
    return request('PUT', '/ftl/order/back', null, null, batchIdRequest, null, null);
  }

  // 批量关闭整车订单
  public static closeFtlOrderUsingPUT(batchIdRequest: FtlOrderBatchIdRequest): Promise<R<string>> {
    return request('PUT', '/ftl/order/close', null, null, batchIdRequest, null, null);
  }

  // 批量删除整车订单
  public static deleteFtlOrderUsingPUT(batchIdRequest: FtlOrderBatchIdRequest): Promise<R<string>> {
    return request('PUT', '/ftl/order/delete', null, null, batchIdRequest, null, null);
  }

  // 整车订单详情
  public static detailFtlOrderUsingGET(orderNo: string): Promise<R<FtlOrderDetailExtResponse>> {
    return request('GET', '/ftl/order/detail', null, { orderNo }, null, null, null);
  }

  // 整车订单详情-司机端
  public static detailFtlOrderCarrierUsingGET(orderNo: string, sign: string): Promise<R<FtlOrderDetailExtResponse>> {
    return request('GET', '/ftl/order/detail-special', null, { orderNo, sign }, null, null, null);
  }

  // 整车订单导出
  public static exportFtlOrderUsingPOST(query: FtlOrderQueryRequest): Promise<void> {
    return request('POST', '/ftl/order/export', null, null, query, null, null);
  }

  // 彻底删除整车订单
  public static forceDeleteFtlOrderUsingPUT(batchIdRequest: FtlOrderBatchIdRequest): Promise<R<string>> {
    return request('PUT', '/ftl/order/forceDelete', null, null, batchIdRequest, null, null);
  }

  // 获取唯一编码
  public static getFtlRouteDetailUsingGET(): Promise<R<string>> {
    return request('GET', '/ftl/order/getUniqueCode', null, null, null, null, null);
  }

  // 整车订单状态计数
  public static ftlOrderStatusCountUsingPOST(query: FtlOrderQueryRequest): Promise<R<OrderCountResponse>> {
    return request('POST', '/ftl/order/orderStatus', null, null, query, null, null);
  }

  // 整车订单列表
  public static pageFtlOrderUsingPOST(query: FtlOrderQueryRequest): Promise<R<IPage<FtlOrderListExtResponse>>> {
    return request('POST', '/ftl/order/page', null, null, query, null, null);
  }

  // 调整整车订单地址顺序
  public static rearrangeFtlOrderUsingPUT(rearrangeRequest: FtlRearrangeRequest): Promise<R<string>> {
    return request('PUT', '/ftl/order/rearrange', null, null, rearrangeRequest, null, null);
  }

  // 更新整车订单司机信息
  public static updateFtlDriverInfoUsingPUT(updateRequest: FtlOrderDriverUpdateRequest): Promise<R<string>> {
    return request('PUT', '/ftl/order/updateDriver', null, null, updateRequest, null, null);
  }

  // 更新整车订单报价
  public static updateFtlOrderPriceUsingPUT(updateRequest: FtlOrderPriceUpdateRequest): Promise<R<string>> {
    return request('PUT', '/ftl/order/updateOrderPrice', null, null, updateRequest, null, null);
  }

  // 更新整车订单提货时间
  public static updateFtlPickDateUsingPUT(updateRequest: FtlOrderPickDateRequest): Promise<R<string>> {
    return request('PUT', '/ftl/order/updatePickDate', null, null, updateRequest, null, null);
  }

  // 更新整车订单关联编号
  public static updateFtlRefNumberUsingPUT(updateRequest: FtlOrderRefNumberUpdateRequest): Promise<R<string>> {
    return request('PUT', '/ftl/order/updateRefNumber', null, null, updateRequest, null, null);
  }

  // 新增/更新整车订单备注
  public static updateFtlRemarkUsingPUT(updateRequest: FtlOrderRemarkUpdateRequest): Promise<R<string>> {
    return request('PUT', '/ftl/order/updateRemark', null, null, updateRequest, null, null);
  }
}
